import React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter } from 'react-router-dom'
import { LanguageProvider } from 'i18n'
import { GlobalStyles, ThemeProvider } from 'themes'
import AssetsProvider from 'hooks/AssetsProvider'

const Providers = ({ children }) => {
  return (
    <>
      <GlobalStyles />
      <LanguageProvider>
        <ThemeProvider>
          <AssetsProvider>
            <BrowserRouter>
              {children}
            </BrowserRouter>
          </AssetsProvider>
        </ThemeProvider>
      </LanguageProvider>
    </>
  )
}

Providers.propTypes = {
  children: PropTypes.any,
}
export default Providers
